function GetRandomKey({ long }) {
    long = !long ? 8 : long;
    // Génère une chaîne de caractères aléatoire de longueur 8/long
    const randomString = Math.random().toString(36).substring(0, long);
    return `key_${randomString}`;
}

export default GetRandomKey;